import hello from "hellojs";
import Vue from "vue";

export default () => {
    hello.init(
        {
            facebook: "2436057726685410",
            google:
                "952777876804-dh9l03n60gsir6g0d6urb5umh7bt8kdd.apps.googleusercontent.com"
        },
        { redirect_uri: "https://tid.nu/login" }
    );
    Vue.prototype.$hello = hello;
};
